'use client';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Input from '@/components/Input';
import { useAppSelector } from '@/store/hooks';
import form from '@/styles/form.module.css';
import styles from './page.module.css';
import useNavigate from '@/hooks/useNavigate';

export default function Page() {
  const user = useAppSelector((state) => state.resetPwdSlice.newCreds);
  const navigate = useNavigate();

  return (
    <div className={`flex-column gap-l ${form.content}`}>
      <form className={`${form.form} gap-l `}>
        <h3 className={form.title}>Récapitulatif</h3>
        <Alert
          title="Votre mot de passe a bien été réinitialisé."
          message="Il peut maintenant se connecter avec son identifiant."
          type="success"
        />
        <Input label="Identifiant" value={user.uid} readOnly />
        <Input
          label="Mot de passe temporaire"
          value={user.user_password}
          helperText="Le mot de passe temporaire est valable 24 heures."
          readOnly
        />
      </form>
      <div className={styles.retour}>
        <Button
          variant="primary"
          size="medium"
          onClick={(e) => {
            e.preventDefault();
            navigate('menu');
          }}
        >
          Retour vers le menu
        </Button>
      </div>
    </div>
  );
}
